import React from 'react';
import PropTypes from 'prop-types';
import { FilterOutlined, CloseOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const Wrapper = styled.div`
  opacity: ${(props) => (props.disabled ? '.35' : '1')};
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};;
`;

const FilterIconButton = ({ disabled, onClick }) => {
  return (
    <Wrapper disabled={disabled} title="Clear Filter" onClick={onClick}>
      <FilterOutlined
        style={{
          fontSize: '16px',
          color: '#1890ff',
        }}
      />
      <CloseOutlined
        style={{
          fontSize: '12px',
          position: 'absolute',
          left: '14px',
          bottom: '7px',
          color: '#f5222d',
        }}
      />
    </Wrapper>
  );
};

FilterIconButton.defaultProps = {
  disabled: false,
  onClick: () => {},
};

FilterIconButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default FilterIconButton;
